
namespace TabAurous.Inventory {

    @Serenity.Decorators.registerClass()

    export class MaterialPaymentDialog extends _Ext.TransDialog<MaterialPaymentRow, any> {

        protected getFormKey() { return MaterialPaymentForm.formKey; }
        protected getIdProperty() { return MaterialPaymentRow.idProperty; }
        protected getLocalTextPrefix() { return MaterialPaymentRow.localTextPrefix; }
        protected getNameProperty() { return MaterialPaymentRow.nameProperty; }
        protected getService() { return MaterialPaymentService.baseUrl; }
        protected getDeletePermission() { return MaterialPaymentRow.deletePermission; }
        protected getInsertPermission() { return MaterialPaymentRow.insertPermission; }
        protected getUpdatePermission() { return MaterialPaymentRow.updatePermission; }
        protected useViewMode() { return true; }

        public form = new MaterialPaymentForm(this.idPrefix);
        statement: string;
        contractTotals: string;
        TaxArray: any[];
        // #region Variables
        public PartyId: number;
        public RateListId: number;
        public LaborListId: number;
        public StoneMarkup: number;
        public StoneDiscount: number;
        public LaborMarkup: number;
        public LaborDiscount: number;
        public TransDate: Date;
        public ExchangeRate: number;
        constructor() {
            super();
            var Config = Q.deepClone(q.DefualtEditorOptions);
            Config.height = 150;
            q.initItemEditor(this, this.form.ItemDetails, Config);

            //Make grid full width
            q.hideEditorLabel(this.form.ItemDetails);
            q.setTextRightAlign(this.form.ExchRate);
            //q.hideEditorLabel(this.form.TaxDetails);
            //q.setTextRightAlign(this.form.NetAmount.element);
            //q.setTextRightAlign(this.form.AdditionalCharges.element);
            //q.setTextRightAlign(this.form.GrossAmount.element);
            //q.setTextRightAlign(this.form.Discount.element);
            //q.setTextRightAlign(this.form.TaxAmount.element);
            q.setGridEditorHeight(this.form.ItemDetails, 200);
            //q.setGridEditorHeight(this.form.TaxDetails.element, 150);
            //q.hideEditorToolbar(this.form.TaxDetails.getGridField());
            //q.hideCaption(this.form.Posted);

            this.form.ItemDetails.slickGrid.setOptions({ forceFitColumns: true });
            var StartDate = OMS.FinancialYearRow.getLookup().itemById[Q.Authorization.userDefinition.FinancialYearId].FromDate;
            var EndDate = OMS.FinancialYearRow.getLookup().itemById[Q.Authorization.userDefinition.FinancialYearId].ToDate;


            var maxDate = new Date(EndDate);
            var minDate = new Date(StartDate);

            var _enddate = new Date().setDate(maxDate.getDate() + 1)
            var _startdate = new Date().setDate(minDate.getDate() - 1)


            //this.form.TransDate.set_maxDate(new Date(_enddate));
            //this.form.TransDate.set_minDate(new Date(_startdate));

            // **** Get Party Details using PartyID **** 
            this.form.PartyId.changeSelect2(e => {

                let PartyDetails;
                OMS.VendorService.Retrieve({
                    EntityId: parseInt(this.form.PartyId.value)
                }, response => {
                    PartyDetails = response.Entity
                }, { async: false });
                this.form.ItemDetails.PartyId = parseInt(this.form.PartyId.value);
                this.form.ItemDetails.RateListId = PartyDetails.CostPricegroupId == null ? 0 : PartyDetails.CostPricegroupId;
                this.form.ItemDetails.StoneMarkup = PartyDetails.StnAddMkp == null ? 0 : PartyDetails.StnAddMkp;
                this.form.ItemDetails.LaborMarkup = PartyDetails.LbrAddMkp == null ? 0 : PartyDetails.LbrAddMkp;
                this.form.ItemDetails.LaborListId = PartyDetails.LbrPricegroupId == null ? 0 : PartyDetails.LbrPricegroupId;
                //this.form.City.value = PartyDetails.City;
                // this.form.State.value = PartyDetails.State;
                // this.form.Country.value = PartyDetails.Country;
                //   this.form.GstVat.value = PartyDetails.GstVat;
                let AddressDetails: OMS.AddressMasterRow;
                OMS.AddressMasterService.GetAddress({
                    LedgerId: parseInt(this.form.PartyId.value)
                },
                    response =>
                        AddressDetails = response.Entity,
                    { async: false }
                );

                if (AddressDetails != null) {
                    this.form.State.value = AddressDetails.StateName;
                    this.form.Country.value = AddressDetails.CountryName;
                    var city = AddressDetails.CityName;
                    let address = AddressDetails.Address1 + ", " + AddressDetails.Address2 + ", " + city + ", "
                        + this.form.State.value + ", " + this.form.Country.value + ", " + AddressDetails.Pincode;
                    this.form.Address1.value = address;

                }
                //   this.form.GrossAmount.value = 0;

            });

            this.form.CurrencyId.changeSelect2(e => {
                var ExchangeDetails = OMS.ExchangeRateRow.getLookup().items.filter(x => x.CurrencyId.toString() == this.form.CurrencyId.value && x.FromDate <= this.form.TransDate.value && x.ToDate >= this.form.TransDate.value)[0];
                this.form.ExchRate.value = ExchangeDetails.ExchRate;
            });
            (this.form.ItemDetails.view as any).onRowCountChanged.subscribe(() => {

                var Items = this.form.ItemDetails.getItems();
                this.CalculateAmountandTax(Items);
            });

            this.validateForm();

        }
        public CalculateAmountandTax(Items: any) {
            var ItemTotal = 0;
            var codearray = [];
            var amtarray = [];
            var TaxDetail = [];
            var ntamt = 0; var gramt = 0; var disc = 0; var tax = 0; var pcs = 0; var nwt = 0; var wt = 0;

            //Items.forEach(function (x)
            for (var x of Items) {
                ntamt += x.NetAmount || 0;
                gramt += x.GrossAmount || 0;
                disc += x.Discount || 0;
                pcs += x.Pieces || 0;
                nwt += x.NetWeight || 0;
                wt += x.Weight || 0;

                if (x.HSN != null || x.HSN != "NA") {
                    var temp = false;
                    for (let i = 0; i < codearray.length; i++) {
                        if (codearray[i] == x.HSN) {
                            amtarray[i] += x.GrossAmount || 0;
                            temp = true;
                        }
                    }

                    if (!temp) {
                        codearray.push(x.HSN);
                        amtarray.push(x.GrossAmount);
                    }
                }
                ItemTotal++;
            };

            //this.form.NetAmount.value = gramt;
            //this.form.Discount.value = disc;

            //this.form.GrossAmount.value = gramt;
            //this.form.Pieces.value = pcs;
            //this.form.Weight.value = wt;
            //this.form.NetWeight.value = nwt;
            this.form.ItemDetails.render;
        }
        protected onDialogOpen() {
            super.onDialogOpen();
            //this.form.ItemDetails.parentDialog = this;

            if (this.isNew) {
                if (this.form.PartyId.value == "") {
                    //this.form.GrossAmount.value = 0;
                    this.form.ItemDetails.PartyId = parseInt(this.form.PartyId.value);

                }

            }
            if (this.form.PartyId.value != "") {
                let PartyDetails: OMS.CustomerRow;
                OMS.CustomerService.Retrieve({ EntityId: this.form.PartyId.value }, response => { PartyDetails = response.Entity }, { async: false });
                this.form.ItemDetails.PartyId = parseInt(this.form.PartyId.value);
                this.form.ItemDetails.RateListId = PartyDetails.CostPricegroupId == null ? 0 : PartyDetails.CostPricegroupId;
                this.form.ItemDetails.StoneMarkup = PartyDetails.StnAddMkp == null ? 0 : PartyDetails.StnAddMkp;
                this.form.ItemDetails.LaborMarkup = PartyDetails.LbrAddMkp == null ? 0 : PartyDetails.LbrAddMkp;
                this.form.ItemDetails.LaborListId = PartyDetails.LbrPricegroupId == null ? 0 : PartyDetails.LbrPricegroupId;
                //this.form.City.value = PartyDetails.City;
                // this.form.State.value = PartyDetails.State;
                // this.form.Country.value = PartyDetails.Country;
                //this.form.GstVat.value = PartyDetails.GstVat;
                let AddressDetails: OMS.AddressMasterRow;
                OMS.AddressMasterService.GetAddress({
                    LedgerId: parseInt(this.form.PartyId.value)
                },
                    response =>
                        AddressDetails = response.Entity,
                    { async: false }
                );

                if (AddressDetails != null) {
                    this.form.State.value = AddressDetails.StateName;
                    this.form.Country.value = AddressDetails.CountryName;
                    var city = AddressDetails.CityName;
                    let address = AddressDetails.Address1 + ", " + AddressDetails.Address2 + ", " + city + ", "
                        + this.form.State.value + ", " + this.form.Country.value + ", " + AddressDetails.Pincode;
                    this.form.Address1.value = address;

                }

                // this.form.GrossAmount.value = 0;

            } else {
                var ExchangeDetails = OMS.ExchangeRateRow.getLookup().items.filter(x => x.CurrencyId.toString() == this.form.CurrencyId.value && x.FromDate <= this.form.TransDate.value && x.ToDate >= this.form.TransDate.value)[0];
                this.form.ExchRate.value = ExchangeDetails.ExchRate;
            }
            //Editable TransDate
            var vouchertypeid = this.form.VoucherTypeId.value;
            var isDateEditable = OMS.VoucherMasterRow.getLookup().items.filter(x => x.VoucherTypeId == vouchertypeid)[0];
            if (isDateEditable != null && isDateEditable.AllowBackDatedEntry) {
                this.form.TransDate.set_readOnly(false);
                var StartDate = OMS.FinancialYearRow.getLookup().itemById[Q.Authorization.userDefinition.FinancialYearId].FromDate;
                var EndDate = OMS.FinancialYearRow.getLookup().itemById[Q.Authorization.userDefinition.FinancialYearId].ToDate;
                var maxDate = new Date(EndDate);
                var minDate = new Date(StartDate);
                q.setMaxDate(this.form.TransDate, maxDate);
                q.setMinDate(this.form.TransDate, minDate);
            }
        }


        protected getToolbarButtons(): Serenity.ToolButton[] {
            let btns = super.getToolbarButtons();

            var btnDelete = Q.first(btns, x => x.cssClass == "delete-button");

            var oldDeleteClick = btnDelete.onClick;

            btnDelete.onClick = e => { this.confirmBeforeDelete(oldDeleteClick, e); };

            //Export PDF Button
            btns.push(TabAurous.Common.ReportHelper.createToolButton({
                title: 'Invoice',
                cssClass: 'export-pdf-button',
                reportKey: 'MaterialPayment.MaterialPayment',
                getParams: () => ({
                    TransID: this.get_entityId()
                })
            }));


            var postingpermission = Q.Authorization.hasPermission('Inventory:MaterialPayment:Posting');
            //Export PDF Button
            btns.push({
                title: 'Post',
                icon: 'las la-check-double',
                cssClass: 'approve-doc-button',
                onClick: () => {
                    var entity = this.entity;
                    entity.AutoPosting = true; delete entity.TransDate;

                    MaterialPaymentService.Update({ Entity: entity, EntityId: entity.TransId }, response => {
                        if (response.Error == null) {
                            this.dialogClose();
                            Serenity.SubDialogHelper.triggerDataChange(this);
                        }
                    }, { async: false })
                },
                visible: postingpermission

            });

            return btns;
        }

        // **** Validate Reference of Voucher in Stock Transaction Before Delete. ****
        private confirmBeforeDelete(oldEvt, e) {
            let self = this;
            let refid: Stock.StockItemRow;
            Stock.StockItemService.CheckTransaction(
                { RefTransId: parseInt(this.form.TransId.value), RefVoucherId: this.form.VoucherTypeId.value },
                response => {
                    if (response.Entities != null && response.Entities.length > 0)
                        refid = response.Entities[0];
                }, { async: false }
            )
            if (refid != null) {
                if (refid.PartyId != null || refid.PartyId > 0) {
                    Q.alert("This Voucher has been used in transactions Can Not Delete!");
                    return;
                }
            } else {
                MaterialPaymentService.Delete(
                    {
                        EntityId: this.entityId
                    }, response => {
                        Serenity.SubDialogHelper.triggerDataChange(self);
                        self.dialogClose();
                        window.setTimeout(() => Q.notifySuccess(Q.text('Deleted successfully')), 0);
                    });
            }

        }

        validateEntity(row: MaterialPaymentRow, id: number) {

            if (row.ItemDetails.length == 0) {
                Q.alert("No Items added, Atleast add one entry. Can not Save! ")
                return false;
            }
        }
    }
}